import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { InsideSection } from '../components/sales/InsideSection';
import { LessonSection } from '../components/sales/LessonSection';
import { BenefitSection } from '../components/sales/BenefitSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { LibrarySection } from '../components/sales/LibrarySection';
import { AfterPurchaseSection } from '../components/sales/AfterPurchaseSection';
import { FaqSection } from '../components/sales/FaqSection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-212" data-mp="3ak8a00mvf5kj">
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-213" data-mp="35sq9teso990m">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-214" data-mp="30tnh8ttvov9j">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-215" data-mp="2vv3u4q3jtdfl">
            Nail Educator Ready™
          </p>
        </div>
      </header>

      <main data-id="element-216" data-mp="3tg87fqymb1bi">
        <HeroSection data-id="element-217" data-mp="3ojr800lyx0j4" />
        <ProblemSection data-id="element-218" data-mp="3oj82xkhf26mi" />
        <TransformationSection data-id="element-219" data-mp="3ok10pvyedlsi" />
        <VolumesSection data-id="element-220" data-mp="3ohon1uzo9xl9" />
        <InsideSection data-id="element-221" data-mp="3jjvewwet6tic" />
        <LessonSection data-id="element-222" data-mp="3jjd7d3mp4sv4" />
        <BenefitSection data-id="element-223" data-mp="3jilg2504than" />
        <AudienceSection data-id="element-224" data-mp="3fitfaegzcffu" />
        <BonusesSection data-id="element-225" data-mp="3fjkysqxaympr" />
        <LibrarySection data-id="element-226" data-mp="3fi1i4z7qi9ng" />
        <AfterPurchaseSection data-id="element-227" data-mp="3fkw0ml76tke8" />
        <FaqSection data-id="element-228" data-mp="284ztmrlnptst" />
        <CheckoutSection data-id="element-229" data-mp="286auaijt2lfp" />
      </main>

      <SiteFooter data-id="element-230" data-mp="283540zzfxdie" />
    </div>;
}